// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"a982e34c","125":"d845b80a","237":"d845b80a","806":"dbcc3f12"}[chunkId] + ".chunk.css";
};